export const SET_SHOW_MODAL: string = `REQUIRE_LOGIN/SET_SHOW_MODAL`;
export const SET_URL: string = `REQUIRE_LOGIN/SET_URL`;
